import React from "react";
import HeaderDesktop from "./HeaderDesktop";
import HeaderMobile from "./HeaderMobile";
import { useScreenSize } from "@telefonica/mistica";
import { strings } from "../../localization";
import { observer } from "mobx-react-lite";
export interface IContentMenu {
	label: string;
	link?: string;
	newTab?: boolean;
  external?: boolean;
}

export interface IContentHeader {
	menu: IContentMenu;
	subMenu?: IContentMenu[];
	onTriggerTagging?(description: string, step?: string): void;
  setIsOpen?: (isOpen: boolean) => void;
}

export interface IHeaderProps {
	contents: IContentHeader[];
	onTriggerTagging?(description: string): void;
}

export const NavBar: React.FC = observer(() => {
	const { isTabletOrSmaller } = useScreenSize();
	const {
		components: { navbar },
	} = strings;
	return isTabletOrSmaller ? <HeaderMobile contents={navbar} /> : <HeaderDesktop contents={navbar} />;
});
